import axios from "axios";
import { toast } from "sonner";

export const fetchUser = () => async (dispatch) => {
    await axios
        .get(`/api/auth/current-user`)
        .then((response) => {
            dispatch({
                type: "SIGN_IN_SUCCESS",
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({ type: "SIGN_IN_FAIL" });
        });
};

export const userSignOut = (history) => async (dispatch) => {
    await axios
        .post(`/api/auth/sign-out`)
        .then((response) => {
            toast.success(response.data.message, {
                duration: 3000,
            });
            dispatch({ type: "SIGN_OUT_SUCCESS" });
            if (response.data.redirect) {
                history.push(response.data.redirect);
            }
        })
        .catch((error) => {
            toast.error(error?.response?.data?.error, {
                duration: 3000,
            });
        });
};

export const userSessionExpired = () => async (dispatch) => {
    await axios
        .post(`/api/auth/session-expired`)
        .then((response) => {
            toast.success(response.data.message, {
                duration: 3000,
            });
            dispatch({ type: "SIGN_OUT_SUCCESS" });
        })
        .catch((error) => {
            toast.error(error?.response?.data?.error, {
                duration: 3000,
            });
        });
};
